import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { X, CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import RekapanCard from './components/RekapanCard';
import LupaAbsenModal from './components/LupaAbsenModal';

const getLocationStayPolicy = (dataKaryawan = {}) => {
  const divisi = String(dataKaryawan.divisi || dataKaryawan.nama_divisi || dataKaryawan.division || '').toLowerCase();
  const kantor = String(dataKaryawan.kantor || dataKaryawan.nama_kantor || dataKaryawan.cabang || dataKaryawan.lokasi || '').toLowerCase();

  if (divisi.includes('pickup')) {
    return { shouldMonitor: false, label: '' };
  }

  if (divisi.includes('outbound') && kantor.includes('sidareja')) {
    return { shouldMonitor: false, label: '' };
  }

  if (divisi.includes('delivery')) {
    return { shouldMonitor: true, label: '30 menit' };
  }

  return { shouldMonitor: true, label: '1 jam' };
};

const Selesai = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showLupaModal, setShowLupaModal] = useState(false);
  const [jamMasuk, setJamMasuk] = useState('');
  const [jamPulang, setJamPulang] = useState('');
  const absenData = location.state?.absenData || {
    status: 'Absen Masuk',
    waktu: '09:20:29',
    tanggal: '2025-11-05',
    jam_masuk: '08:00',
    jam_pulang: '17:00',
    telat: 80,
    bolos: 0,
  };

  const riwayat = JSON.parse(localStorage.getItem("riwayat_absen")) || [];
  const riwayatServer = JSON.parse(localStorage.getItem("absen_server") || "[]");
  const dataKaryawan = JSON.parse(localStorage.getItem("data_karyawan") || "{}");
  const stayPolicy = getLocationStayPolicy(dataKaryawan);
  const tanggalMySQL = absenData.tanggal;

  const absenMasuk = riwayat.find(
    (item) => item.tanggal === tanggalMySQL && item.status === "Absen Masuk"
  );
  const absenPulang = riwayat.find(
    (item) => item.tanggal === tanggalMySQL && item.status === "Absen Pulang"
  );

  const waktuMasuk = absenMasuk ? absenMasuk.waktu : "00:00:00";
  const waktuPulang = absenPulang ? absenPulang.waktu : "00:00:00";

  let uangMakan = "Rp 0";
  if (absenMasuk && absenPulang && absenMasuk.telat === 0 && absenPulang.bolos === 0) {
    uangMakan = "Rp 12.500";
  }

  const statusTampil = absenPulang ? "Absen Pulang" : absenMasuk ? "Absen Masuk" : "Belum Absen";
  const waktuTampil = absenPulang ? waktuPulang : absenMasuk ? waktuMasuk : "--:--";

  const dataTampil = {
    status: statusTampil,
    waktu: waktuTampil,
    jam_masuk: absenData.jam_masuk || "08:00",
    jam_pulang: absenData.jam_pulang || "17:00",
    telat: absenMasuk?.telat || 0,
    bolos: absenPulang?.bolos || 0,
    uang_makan: uangMakan,
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: "linear-gradient(180deg, #F5F9FF 0%, #E8F1FF 40%, #FFFFFF 100%)",
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      fontFamily: 'Poppins, sans-serif',
      padding: '20px 16px',
      boxSizing: 'border-box',
      gap: 16,
    }}>
      
      {/* Tombol X */}
      <motion.button
          onClick={() => navigate('/')}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          whileTap={{ scale: 0.9 }}
          style={{
            position: 'absolute',
            top: 15,
            left: 15,
            width: 40,
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#fff',
            borderRadius: '50%',
            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
            cursor: 'pointer',
            border: 'none',
            zIndex: 10,
          }}
          aria-label="Kembali"
        >
          <X size={22} color="#333" />
        </motion.button>

      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        style={{ textAlign: 'center', width: '100%', maxWidth: 400, marginTop: 60 }}
      >
        <CheckCircle size={70} color="#22c55e" style={{ margin: '0 auto' }} />
        <h2 style={{
          margin: '10px 0 5px',
          fontWeight: 'bold',
          color: '#222',
          fontSize: 20
        }}>
          Absen Anda Berhasil
        </h2>
        {dataTampil.status === 'Absen Masuk' && stayPolicy.shouldMonitor && (
          <div style={{
            margin: '14px auto 0',
            backgroundColor: '#fef3c7',
            color: '#b91c1c',
            border: '1px solid #f59e0b',
            borderRadius: 12,
            padding: '10px 12px',
            fontSize: 13,
            fontWeight: 800,
            lineHeight: 1.4,
            maxWidth: 360,
            boxShadow: '0 4px 10px rgba(245, 158, 11, 0.16)',
          }}>
            Absen masuk valid jika dalam {stayPolicy.label} setelah absen tidak meninggalkan lokasi.
          </div>
        )}
      </motion.div>

      {/* KARTU ABSEN */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        style={{
          backgroundColor: '#fff',
          borderRadius: 24,
          padding: 20,
          width: '100%',
          maxWidth: 400,
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          border: '1px solid #e5e7eb',
          boxSizing: 'border-box',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <div style={{
            width: 50, height: 50, borderRadius: '50%', overflow: 'hidden',
            border: '2px solid #22c55e', flexShrink: 0
          }}>
            <img
              src="https://cdn-icons-png.flaticon.com/512/9131/9131529.png"
              alt="Avatar"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ color: '#22c55e', fontWeight: 700, fontSize: 16 }}>
              {dataTampil.status}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 4 }}>
              <div style={{ fontSize: 28, fontWeight: 'bold' }}>{dataTampil.waktu}</div>
              <div style={{
                backgroundColor: dataTampil.telat === 0 ? '#f97316' : '#ef4444',
                color: '#fff', padding: '4px 12px', borderRadius: 20,
                fontSize: 13, fontWeight: 500
              }}>
                {dataTampil.telat === 0 ? 'On time' : 'Telat'}
              </div>
            </div>
          </div>
        </div>

        <div style={{
          backgroundColor: '#f0fdf4',
          borderRadius: 12,
          padding: 12,
          border: '1px solid #bbf7d0',
          textAlign: 'center',
          marginTop: 16
        }}>
          {/* PESAN TELAT & UANG MAKAN - DINAMIS BERDASARKAN STATUS */}
          {dataTampil.status === 'Absen Masuk' ? (
            <>
              <p style={{ color: '#4b5563', fontSize: 14, margin: 5 }}>
                {dataTampil.telat === 0 
                  ? 'On time. Good job!' 
                  : 'Anda telat masuk.'
                }
              </p>
              <p style={{ color: '#16a34a', fontSize: 13, fontWeight: 500 }}>
                {dataTampil.telat === 0 
                  ? 'Uang makan akan muncul setelah absen pulang' 
                  : 'Anda tidak berhak mendapatkan Uang Makan.'
                }
                
              </p>
            </>
          ) : dataTampil.status === 'Absen Pulang' ? (
            <>
              <p style={{ color: '#4b5563', fontSize: 14, margin: 5 }}>
                {dataTampil.telat === 0 && dataTampil.bolos === 0 
                  ? 'On time. Good job!' 
                  : 'Ada keterlambatan atau bolos.'
                }
              </p>
              <p style={{ 
                color: (dataTampil.telat === 0 && dataTampil.bolos === 0) ? '#16a34a' : '#dc2626', 
                fontSize: 13, 
                fontWeight: 500 
              }}>
                {dataTampil.telat === 0 && dataTampil.bolos === 0
                  ? 'Anda berhak mendapatkan Uang Makan Rp 12.500'
                  : 'Anda tidak berhak mendapatkan Uang Makan.'
                }
              </p>
            </>
          ) : null}
        </div>
      </motion.div>

      {/* JAM KERJA */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        style={{
          backgroundColor: '#fff',
          borderRadius: 24,
          padding: 20,
          width: '100%',
          maxWidth: 400,
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
          border: '1px solid #e5e7eb',
          boxSizing: 'border-box',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
          <h3 style={{ color: '#111827', fontWeight: 700, fontSize: 15, margin: 0 }}>Jam Kerja</h3>
          <div style={{
            backgroundColor: '#f3f4f6', borderRadius: 10,
            padding: '6px 12px', fontSize: 13, color: '#374151'
          }}>
            {dataTampil.jam_masuk} - {dataTampil.jam_pulang}
          </div>
        </div>

        <div style={{
          display: 'flex', justifyContent: 'space-between',
          backgroundColor: '#f9fafb', borderRadius: 12, padding: '14px 18px',
          border: '1px solid #e5e7eb', marginBottom: 12
        }}>
          <div style={{ flex: 1, textAlign: 'center' }}>
            <p style={{ margin: 0, color: '#111827', fontWeight: 600, fontSize: 14 }}>Absen Masuk</p>
            {dataTampil.status === 'Absen Pulang' && waktuMasuk === '00:00:00' ? (
              <button
                onClick={() => setShowLupaModal(true)}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  fontSize: 20,
                  fontWeight: 'bold',
                  color: '#dc2626',
                  display: 'block',
                  width: '100%',
                  textAlign: 'center',
                  marginTop: 2,
                  textDecoration: 'none',
                }}
              >
                Lupa Absen
              </button>
            ) : (
              <span style={{ fontSize: 22, fontWeight: 'bold', color: '#111827' }}>
                {waktuMasuk === '00:00:00' ? '--:--:--' : waktuMasuk}
              </span>
            )}
          </div>

          <div style={{ width: 1, height: 50, backgroundColor: '#e5e7eb', alignSelf: 'center' }}></div>
          <div style={{ flex: 1, textAlign: 'center' }}>
            <p style={{ margin: 0, color: '#111827', fontWeight: 600, fontSize: 14 }}>Absen Pulang</p>
            <span style={{ fontSize: 22, fontWeight: 'bold', color: '#111827' }}>
              {waktuPulang === "00:00:00" ? "--:--:--" : waktuPulang}
            </span>
          </div>
        </div>

        <div style={{
          display: 'flex', justifyContent: 'space-between',
          backgroundColor: '#f9fafb', borderRadius: 12, padding: '14px 18px',
          border: '1px solid #e5e7eb'
        }}>
          <div style={{ flex: 1, textAlign: 'center' }}>
            <p style={{ margin: 0, color: '#111827', fontWeight: 600, fontSize: 14 }}>Telat</p>
            <p style={{ margin: '4px 0 0', color: dataTampil.telat > 0 ? '#dc2626' : '#16a34a', fontSize: 13, fontWeight: 500 }}>
              {dataTampil.telat} menit
            </p>
          </div>
          <div style={{ width: 1, height: 50, backgroundColor: '#e5e7eb', alignSelf: 'center' }}></div>
          <div style={{ flex: 1, textAlign: 'center' }}>
            <p style={{ margin: 0, color: '#111827', fontWeight: 600, fontSize: 14 }}>Bolos</p>
            <p style={{ margin: '4px 0 0', color: dataTampil.bolos > 0 ? '#dc2626' : '#16a34a', fontSize: 13, fontWeight: 500 }}>
              {dataTampil.bolos} menit
            </p>
          </div>
        </div>
      </motion.div>

      {/* Google Review */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        style={{
          width: '100%',
          maxWidth: 400,
          borderRadius: 24,
          padding: 0,
          
        }}
      >
        <RekapanCard items={riwayatServer} />
      </motion.div>

      {/* Modal Lupa Absen Masuk */}
      <LupaAbsenModal
        open={showLupaModal}
        onClose={() => setShowLupaModal(false)}
        lupaType="lupa_masuk"
        items={[{ tanggal: absenData.tanggal }]}
        jamMasuk={jamMasuk}
        setJamMasuk={setJamMasuk}
        jamPulang={jamPulang}
        setJamPulang={setJamPulang}
        dataKaryawan={dataKaryawan}
      />
    </div>
  );
};

export default Selesai;
